module.exports = __webpack_public_path__ + "static/content-1-mobile-5a7e548fe34e293a7d907ed5a7b1b4e0.png";